import { apiUrl } from '../config/api'

export async function listCaptains() {
  const r = await fetch(apiUrl('/api/admin/captains'))
  if (!r.ok) throw new Error('failed')
  return r.json()
}

export async function createCaptain(payload) {
  const r = await fetch(apiUrl('/api/admin/captains'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  const body = await r.json().catch(() => null)
  return { ok: r.ok, status: r.status, body }
}

export async function patchCaptain(userId, payload) {
  const r = await fetch(apiUrl(`/api/admin/captains/${userId}`), {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  const body = await r.json().catch(() => null)
  return { ok: r.ok, status: r.status, body }
}

export async function getCaptainDashboard(userId) {
  const r = await fetch(apiUrl(`/api/admin/captains/${userId}/dashboard`))
  if (!r.ok) throw new Error('failed')
  return r.json()
}

export async function getCaptainPreferredLocations(userId) {
  const r = await fetch(apiUrl(`/api/admin/captains/${userId}/preferred-locations`))
  if (!r.ok) throw new Error('failed')
  return r.json()
}

export async function setCaptainPreferredLocations(userId, deliveryLocationIds) {
  const r = await fetch(apiUrl(`/api/admin/captains/${userId}/preferred-locations`), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ deliveryLocationIds }),
  })
  const body = await r.json().catch(() => null)
  return { ok: r.ok, status: r.status, body }
}
